module.exports = __webpack_public_path__ + "img/footer_logo.c7e123e7.svg";